import { apiClient } from './apiClient';

export const createMessage = async (params?: any) => {
  const { data } = await apiClient.post(`messages`, params);
  return data;
};

export const deleteAlertRequest = (alertId: string) => apiClient.delete(`alerts/${alertId}`);
